import { Component, Input, OnInit } from "@angular/core";
import { TrainService } from "@core/services";

@Component({
  selector: "app-train-info-modal",
  templateUrl: "./train-info-modal.component.html",
  styleUrls: ["./train-info-modal.component.scss"],
})
export class TrainInfoModalComponent implements OnInit {
  @Input() train: any;
  constructor(public trainService: TrainService) { }

  ngOnInit(): void {}

  getWaitDuration(i: number) {
    const actualSection = this.train.legs[i]
    const nextSection = this.train.legs[i+1]
    const date1 = new Date(nextSection.departDate);
    const date2 = new Date(actualSection.arriveDate);

    const diffMs = Math.abs(date1.getTime() - date2.getTime()); // diferencia en milisegundos

    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMin = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${diffHrs} h ${diffMin} min`;
  }

}